import React, { Fragment } from 'react';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Img from 'gatsby-image';

import styles from './amelie.module.css';

const Amelie = ({ data: { datoCmsAmelie } }) => (
  <div>
    <HelmetDatoCms seo={datoCmsAmelie.seoMetaTags} />
    <Img sizes={datoCmsAmelie.image.sizes} />
    <p>
      <span className="uppercase">Contactez moi :) ?</span>
      <br />
      <a href={`mailto:${datoCmsAmelie.email}`}>{datoCmsAmelie.email}</a>
    </p>
    <div className={`${styles.cv}`}>
      {datoCmsAmelie.cv.map(({ years, experience }, index) => (
        <Fragment key={index}>
          {years && <h2>{years}</h2>}
          <p>{experience}</p>
        </Fragment>
      ))}
    </div>
  </div>
);

export default Amelie;

export const query = graphql`
  query AmelieQuery {
    datoCmsAmelie {
      image {
        sizes(maxWidth: 960, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsSizes_noBase64
        }
      }
      email
      cv {
        years
        experience
      }
      seo {
        title
        description
      }
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/amelie.js